export default {
      id: "icon-plus-usage",
      viewBox: "0 0 16 16",
      url: "/" + "assets/sprite.svg#icon-plus",
      toString: function () {
        return this.url;
      }
    }